import { render, staticRenderFns } from "./shareWX.vue?vue&type=template&id=6f596f0e&scoped=true"
import script from "./shareWX.vue?vue&type=script&lang=js"
export * from "./shareWX.vue?vue&type=script&lang=js"
import style0 from "./shareWX.vue?vue&type=style&index=0&id=6f596f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f596f0e",
  null
  
)

export default component.exports